/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once a day is enough to see real progress — typing speed improves gradually, and testing more often just adds noise from tiredness or an unfamiliar passage. Track your score over a few weeks rather than comparing one test to the next; the trend matters more than any single run.`)
};

const es_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vez al día es suficiente para ver progreso real — la velocidad de mecanografía mejora poco a poco, y hacer el test más seguido solo añade ruido por el cansancio o un texto poco familiar. Sigue tu puntuación durante varias semanas en lugar de comparar un test con el siguiente; la tendencia importa más que cualquier resultado individual.`)
};

const de_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmal am Tag reicht aus, um echten Fortschritt zu sehen — die Tippgeschwindigkeit verbessert sich schrittweise, und häufigeres Testen bringt nur zusätzliches Rauschen durch Müdigkeit oder einen ungewohnten Textabschnitt. Verfolge deinen Wert über mehrere Wochen, statt einen Test mit dem nächsten zu vergleichen — der Trend zählt mehr als ein einzelner Durchlauf.`)
};

const nl_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén keer per dag is genoeg om echte vooruitgang te zien — typsnelheid verbetert geleidelijk, en vaker testen voegt vooral ruis toe door vermoeidheid of een onbekende passage. Volg je score over een paar weken in plaats van één test met de volgende te vergelijken; de trend is belangrijker dan een losse meting.`)
};

const fr_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois par jour suffit pour voir de réels progrès — la vitesse de frappe s'améliore progressivement, et tester plus souvent ne fait qu'ajouter du bruit lié à la fatigue ou à un passage inhabituel. Suivez votre score sur plusieurs semaines plutôt que de comparer un test au suivant ; la tendance compte plus que n'importe quel résultat isolé.`)
};

const it_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una volta al giorno è sufficiente per vedere progressi reali — la velocità di digitazione migliora gradualmente, e testare più spesso aggiunge solo rumore dovuto a stanchezza o a un passaggio poco familiare. Monitora il tuo punteggio nel corso di qualche settimana invece di confrontare un test con il successivo; la tendenza conta più di qualsiasi singola prova.`)
};

const pt_br2_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma vez por dia já é suficiente para ver progresso real — a velocidade de digitação melhora aos poucos, e testar com mais frequência só adiciona ruído por causa do cansaço ou de um trecho pouco familiar. Acompanhe sua pontuação ao longo de algumas semanas em vez de comparar um teste com o próximo; a tendência importa mais do que qualquer teste isolado.`)
};

const pt_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma vez por dia é suficiente para ver progresso real — a velocidade de escrita melhora gradualmente, e testar com mais frequência só acrescenta ruído devido ao cansaço ou a uma passagem pouco familiar. Acompanhe a sua pontuação ao longo de algumas semanas em vez de comparar um teste com o seguinte; a tendência importa mais do que qualquer teste isolado.`)
};

const ja_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1日1回で十分に上達を確認できます。タイピング速度は徐々に向上するものであり、頻繁にテストしても疲労や不慣れな文章によるノイズが増えるだけです。1回ごとのスコアを比較するのではなく、数週間かけての傾向を追いましょう。1回の結果よりも全体の傾向の方が重要です。`)
};

const zh_typing_u1_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每天一次就足以看到真正的进步 — 打字速度是逐渐提高的，测试太频繁只会因为疲劳或陌生文本而增加干扰。请追踪几周内的分数变化，而不是逐次比较；趋势比任何单次测试都更重要。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u1_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u1_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u1_faq4_a", locale)
	if (locale === "en") return en_typing_u1_faq4_a(inputs)
	if (locale === "es") return es_typing_u1_faq4_a(inputs)
	if (locale === "de") return de_typing_u1_faq4_a(inputs)
	if (locale === "nl") return nl_typing_u1_faq4_a(inputs)
	if (locale === "fr") return fr_typing_u1_faq4_a(inputs)
	if (locale === "it") return it_typing_u1_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u1_faq4_a(inputs)
	if (locale === "pt") return pt_typing_u1_faq4_a(inputs)
	if (locale === "ja") return ja_typing_u1_faq4_a(inputs)
	return zh_typing_u1_faq4_a(inputs)
};